module.exports = __webpack_public_path__ + "media/images/common/order-37e47fdeee2336f3f6bde61e23ce1964.png";